<nz-layout>
    <nz-content>
        <nz-spin [nzSpinning]="updating$ | async">
            <form nz-form nzLayout="inline" [formGroup]="validateForm">
                <nz-form-item>
                    <nz-form-label>Order ID</nz-form-label>
                    <nz-form-control nzErrorTip="Please input order id or create new order!">
                        <input nz-input formControlName="orderId" placeholder="" />
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-control>
                        <button nz-button nzType="primary" (click)="openFindOrder()">
                            Find Order
                        </button>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                    <nz-form-control>
                        <button nz-button nzType="primary" (click)="openCreateOrder()">
                            Create Order
                        </button>
                    </nz-form-control>
                </nz-form-item>
            </form>
            <div>
                <nz-table #basicTable [nzData]="tableData" [nzFrontPagination]="false">
                    <thead>
                        <tr>
                            <th>Drug Name</th>
                            <th>DIN</th>
                            <th>Mitte</th>
                            <th>Refills</th>
                            <th>Auth</th>
                            <th>Rem</th>
                            <th>Dispense</th>
                            <th>Tx Number</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of basicTable.data">
                            <td>{{ data.name }}</td>
                            <td>{{ data.din }}</td>
                            <td>{{ data.mitte }}</td>
                            <td>{{ data.refills }}</td>
                            <td>{{ quantities[data.din].authQty }}</td>
                            <td>{{ quantities[data.din].remainQty }}</td>
                            <td>
                                <nz-input-number [name]="'qty' + data.din" [(ngModel)]="data.qty"
                                    (ngModelChange)="validQty(data.din)" [nzMin]="0" required></nz-input-number>
                            </td>
                            <td>
                                <nz-input-number [name]="'txNumber' + data.din" [(ngModel)]="data.txNumber"
                                    [nzMin]="0"></nz-input-number>
                            </td>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
            <nz-alert 
                *ngIf="validationError" 
                nzType="error" 
                [nzMessage]="validationError" 
                nzShowIcon
                nzCloseable
                (nzOnClose)="validationError = ''"
                style="margin-bottom: 16px;">
            </nz-alert>
            <button nz-button nzType="primary" (click)="addFulfillment()" [disabled]="updating$ | async">
                Save & Close
            </button>

            <div *ngIf="rx?.fulfillments?.length">
                <nz-divider nzText="Fulfillment History" nzOrientation="left"></nz-divider>
                <nz-timeline nzMode="left">
                    <nz-timeline-item *ngFor="let fulfillment of rx.fulfillments" [nzLabel]="
                            fulfillment.createdAt | date : 'MMM d, y, h:mm a'
                        ">
                        <nz-tag>Order ID: {{ fulfillment.orderId }}</nz-tag>

                        <nz-tag *ngIf="fulfillment?.updatedBy as userId">
                            <ng-container
                                *ngTemplateOutlet="userName; context: { $implicit: (userId | userDetails | async) }"></ng-container>
                        </nz-tag>

                        <ul>
                            <li *ngFor="let drug of fulfillment.drugs" class="italic">
                                {{ drug.name }} x{{ drug.qty }}
                                <span *ngIf="drug.txNumber">
                                    - Tx Number: {{ drug.txNumber }}
                                </span>
                            </li>
                        </ul>
                    </nz-timeline-item>
                </nz-timeline>
            </div>
        </nz-spin>
    </nz-content>
</nz-layout>

<nz-modal [(nzVisible)]="showModal" nzTitle="Mark order as awaiting shipment" nzOkText="Mark as shipped"
    [nzFooter]="modalFooter" (nzOnCancel)="handleNo()">
    <ng-container *nzModalContent>
        <p>Mark order as awaiting shipment?</p>
    </ng-container>
    <ng-template #modalFooter>
        <button nz-button nzType="primary" (click)="handleYes()">Yes</button>
        <button nz-button nzType="default" (click)="handleNo()">No</button>
    </ng-template>
    <ng-template #userName let-user>
        {{ user?.firstName }} {{ user?.lastName }}
    </ng-template>

</nz-modal>